import { render, staticRenderFns } from "./resumo-dados-basicos.vue?vue&type=template&id=d082cec4&scoped=true"
import script from "./resumo-dados-basicos.vue?vue&type=script&lang=js"
export * from "./resumo-dados-basicos.vue?vue&type=script&lang=js"
import style0 from "./resumo-dados-basicos.vue?vue&type=style&index=0&id=d082cec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d082cec4",
  null
  
)

export default component.exports